/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadWaitlistDetails
 */
export interface PalAuthSubmissionLeadWaitlistDetails {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlistDetails
     */
    status_set_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadWaitlistDetails
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadWaitlistDetails interface.
 */
export function instanceOfPalAuthSubmissionLeadWaitlistDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionLeadWaitlistDetailsFromJSON(json: any): PalAuthSubmissionLeadWaitlistDetails {
    return PalAuthSubmissionLeadWaitlistDetailsFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadWaitlistDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_set_date': !exists(json, 'status_set_date') ? undefined : json['status_set_date'],
        'status_set_reason': !exists(json, 'status_set_reason') ? undefined : json['status_set_reason'],
    };
}

export function PalAuthSubmissionLeadWaitlistDetailsToJSON(value?: PalAuthSubmissionLeadWaitlistDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_set_date': value.status_set_date,
        'status_set_reason': value.status_set_reason,
    };
}

